import React, { Component } from "react";
import WidgetPageRenderer from "../widgets/WidgetPageRenderer";

import LoadingOverlay from "./LoadingOverlay";
export default class Widgetsrightstable_NEW extends Component {
  render() {
    return <WidgetPageRenderer pageRoute="widgetsrightstable" />;
  }
}
